/**
 * Quick subscribe link — reads the page URL, fills the hidden cart form and
 * submits it natively so the browser lands on the checkout with the
 * subscription attached.
 *
 * URL parameters (all optional):
 *   plan      60 | 30 | dual | <selling plan id>
 *   qty       1-10 (dual defaults to the section's dual quantity)
 *   discount  a discount code applied on the checkout
 *   email, first, last, address1, address2, city, province, zip, country,
 *   phone, company  → pre-fill the checkout contact and shipping address
 *
 * The submit is a real form post, never fetch: the subscription app patches
 * window.fetch on /cart/add and would replace the plan with its own state.
 */
(function () {
  var root = document.querySelector('[data-quick-subscribe]');
  if (!root || root.getAttribute('data-ready') !== 'true') return;

  var form = root.querySelector('[data-quick-subscribe-form]');
  if (!form) return;

  var planInput = form.querySelector('[name="selling_plan"]');
  var qtyInput = form.querySelector('[name="quantity"]');
  var returnInput = form.querySelector('[name="return_to"]');
  var button = form.querySelector('[data-quick-subscribe-button]');
  if (!planInput || !qtyInput || !returnInput) return;

  var data = { aliases: {}, plans: {}, dualQuantity: 2 };
  var dataNode = root.querySelector('[data-quick-subscribe-data]');
  if (dataNode) {
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (e) {
      /* keep the server-rendered defaults */
    }
  }

  var params = new URLSearchParams(window.location.search);

  // --- plan -----------------------------------------------------------
  var requested = (params.get('plan') || '').trim().toLowerCase();
  var alias = '';
  if (requested) {
    var candidate = '';
    if (/^\d+$/.test(requested)) {
      candidate = requested;
    } else if (data.aliases && data.aliases[requested]) {
      candidate = String(data.aliases[requested]);
      alias = requested;
    }
    // Only plans the product actually carries — an unknown id would make
    // /cart/add answer with an error page instead of the checkout.
    if (candidate && data.plans && data.plans[candidate]) {
      planInput.value = candidate;
    }
  }

  // --- variant --------------------------------------------------------
  // Once the product is split per offer, each plan lives on its own
  // variant; the section hands over which one. With a single variant the
  // map is empty and the form keeps the variant it was rendered with.
  var idInput = form.querySelector('[name="id"]');
  if (idInput && data.variants) {
    var aliases = data.aliases || {};
    var variantKey = alias;
    if (!variantKey) {
      if (planInput.value === String(aliases.dual)) variantKey = 'dual';
      else if (planInput.value === String(aliases['30'])) variantKey = '30';
      else variantKey = '60';
    }
    var variantId = data.variants[variantKey];
    if (variantId) idInput.value = String(variantId);
  }

  // --- quantity -------------------------------------------------------
  var qty = parseInt(params.get('qty'), 10);
  if (qty > 0 && qty <= 10) {
    qtyInput.value = String(qty);
  } else if (alias === 'dual') {
    qtyInput.value = String(data.dualQuantity || 2);
  }

  // --- "Includes" note --------------------------------------------------
  // The link always buys a subscription, so the note is on unless the
  // merchant blanked the text for this kind of plan.
  var includes = form.querySelector('[data-quick-subscribe-includes]');
  if (includes) {
    var kind = alias === 'dual' || planInput.value === String((data.aliases || {}).dual) ? 'dual' : 'single';
    var note = includes.getAttribute('data-' + kind) || '';
    if (note) {
      includes.value = note;
      includes.disabled = false;
    } else {
      includes.disabled = true;
    }
  }

  // --- summary line ---------------------------------------------------
  var plan = data.plans && data.plans[planInput.value];
  if (plan) {
    var nameEl = root.querySelector('[data-quick-subscribe-plan-name]');
    var priceEl = root.querySelector('[data-quick-subscribe-plan-price]');
    if (nameEl) nameEl.textContent = plan.name;
    if (priceEl) priceEl.textContent = plan.price;
  }

  // --- checkout pre-fill ---------------------------------------------
  var prefill = {
    email: 'checkout[email]',
    first: 'checkout[shipping_address][first_name]',
    last: 'checkout[shipping_address][last_name]',
    company: 'checkout[shipping_address][company]',
    address1: 'checkout[shipping_address][address1]',
    address2: 'checkout[shipping_address][address2]',
    city: 'checkout[shipping_address][city]',
    province: 'checkout[shipping_address][province]',
    zip: 'checkout[shipping_address][zip]',
    country: 'checkout[shipping_address][country]',
    phone: 'checkout[shipping_address][phone]',
    discount: 'discount'
  };
  var checkoutParams = new URLSearchParams();
  Object.keys(prefill).forEach(function (key) {
    var value = params.get(key);
    if (value) checkoutParams.append(prefill[key], value.trim());
  });
  var query = checkoutParams.toString();
  returnInput.value = '/checkout' + (query ? '?' + query : '');

  // --- submit ---------------------------------------------------------
  if (root.getAttribute('data-auto-submit') !== 'true') return;

  var submitted = false;
  function go() {
    if (submitted) return;
    submitted = true;
    if (button) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-busy', 'true');
    }
    // form.submit() skips submit listeners on purpose: nothing else on the
    // page gets a chance to rewrite the fields.
    form.submit();
  }

  if (root.getAttribute('data-clear-cart') === 'true') {
    // XMLHttpRequest rather than fetch, for the same reason as above.
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/clear.js', true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = go;
    xhr.onerror = go;
    xhr.ontimeout = go;
    xhr.timeout = 5000;
    try {
      xhr.send();
    } catch (e) {
      go();
    }
  } else {
    go();
  }
})();
